<template>
  <div>
    <vx-card>
      <data-table
        :column-defs="columnDefs"
        :default-col-def="defaultColDef"
        :row-data="rowData"
        :total="total"
        :current-page="currentPage"
        :grid-options="gridOptions"
        :pagination-page-size="pageSize"
        :columnsToFit="true"
        pagination
        @update:current-page="onUpdateCurrentPage"
        @update:pagination-page-size="onUpdatePaginationPageSize"
      >
        <template #actions>
          <vs-button
            class="ml-4"
            @click="onClick"
          >
            登録
          </vs-button>
        </template>
      </data-table>
    </vx-card>
    <form-modal
      v-model="showAudienceForm"
      title="オーディエンスの登録"
      submit-button-text="登録"
      class="ad-audience-modal"
      :disabled="audience.audienceCategory == null || isEdit"
      @click:submit="onClickSubmit"
    >
      <template #content>
        <ValidationForm
          ref="amcAudienceFormObserver"
        >
          <AmcAudienceForm
            v-model:audience-category="audience.audienceCategory"
            v-model:advertiser-id="audience.advertiserId"
            v-model:name="audience.audienceName"
            v-model:description="audience.audienceDescription"
            v-model:params="audience.params"
            v-model:audience1="audience.audience1"
            v-model:audience2="audience.audience2"
            v-model:audience3="audience.audience3"
            v-model:audience4="audience.audience4"
            v-model:audience5="audience.audience5"
            v-model:audience6="audience.audience6"
            v-model:audience7="audience.audience7"
            :isEdit="isEdit"
            class="mb-10"
            ref="amcAudienceForm"
            @update:audience-category="onChangeAudienceCategory"
          />
        </ValidationForm>
      </template>
    </form-modal>
    <form-modal
      v-model="showDeliveryRegisterForm"
      title="スポンサー広告での配信設定"
      submit-button-text="登録"
      class="ad-audience-delivery-register-modal"
      @click:submit="onClickDeliverySubmit"
    >
      <template #content>
        <ValidationForm
          ref="amcAudienceDeliveryRegisterFormObserver"
        >
          <AmcAudienceDeliveryRegisterForm
            v-model:advertiser-id="audience.advertiserId"
            v-model:name="audience.audienceName"
            v-model:ad-type="audience.adType"
            v-model:campaign-id="audience.campaignId"
            v-model:campaign-name="audience.campaignName"
            v-model:bid-ajustment="audience.bidAjustment"
            v-model:campaign-and-ad-group="audience.campaignAndAdGroup"
            v-model:ad-group-id="audience.adGroupId"
            v-model:ad-group-name="audience.adGroupName"
            v-model:bid="audience.bid"
            class="mb-10"
          />
        </ValidationForm>
      </template>
    </form-modal>
    <form-modal
      v-model="showDeliveryListForm"
      title="スポンサー広告での配信設定の一覧"
      class="ad-audience-delivery-list-modal"
      :hidden="true"
    >
      <template #content>
        <AmcAudienceDeliveryListForm
          v-model:audience-id="audience.id"
          v-model:advertiser-id="audience.advertiserId"
          v-model:name="audience.audienceName"
          class="mb-10"
        />
      </template>
    </form-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataTable from '@/components/table/DataTable'
import FormModal from '@/components/modals/FormModal'
import AmcAudienceForm from '@/components/forms/AmcAudienceForm'
import AmcAudienceDeliveryRegisterForm from '@/components/forms/AmcAudienceDeliveryRegisterForm'
import AmcAudienceDeliveryListForm from '@/components/forms/AmcAudienceDeliveryListForm'
import DataTableCellAudience from '@/components/table/DataTableCellAudience'
import { debounce } from '@/utils'
import audienceCategory from '@/constants/audienceCategory'

export default {
  components: {
    DataTable,
    FormModal,
    AmcAudienceForm,
    AmcAudienceDeliveryRegisterForm,
    AmcAudienceDeliveryListForm
  },
  data () {
    return {
      currentPage: 1,
      total: 0,
      pageSize: 20,
      defaultColDef: {
        sortable: false,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'アクション',
          cellRenderer: 'dataTableCellAudience',
          cellRendererParams : {
            onClickAudience : this.onClickAudience,
            onClickRegister : this.onClickRegister,
            onClickDelivery: this.onClickDelivery
          },
          width: 160
        },
        {
          headerName: 'オーディエンスカテゴリー',
          field: 'audienceCategory',
          valueFormatter: (params) => {
            return audienceCategory[params.value]
          },
          width: 160
        },
        {
          headerName: '名前',
          field: 'audienceName'
        },
        {
          headerName: '説明',
          field: 'audienceDescription'
        },
        {
          headerName: 'サイズ',
          field: 'audienceCount',
          width: 160
        },
        {
          headerName: '作成日',
          field: 'createdAt',
          width: 160
        },
        {
          headerName: 'ステータス',
          field: 'status',
          valueFormatter (params) {
            return params.value ? params.value : '未実行'
          },
          width: 160
        },
        {
          headerName: 'エラー内容',
          field: 'statusReason',
        }
      ],
      gridOptions: {
        autoSizeStrategy: {
          type: 'fitCellContents'
        },
      },
      editId: -1, // 編集対象ID
      showAudienceForm: false,
      showDeliveryRegisterForm: false,
      showDeliveryListForm: false,
      audience: {
        audienceCategory: null,
        advertiserId: null,
        audienceName: null,
        audienceDescription: null,
        params: null,
        audience1: [],
        audience2: [],
        audience3: [],
        audience4: [],
        audience5: [],
        audience6: [],
        audience7: [],
        adType: null,
        campaignId: null,
        campaignName: null,
        bidAjustment: null,
        campaignAndAdGroup: null,
        adGroupId: null,
        adGroupName: null,
        bid: null
      }
    }
  },
  computed: {
    ...mapState('amcAudience', ['advertisers', 'categories', 'audiences']),
    ...mapState('account', ['activeAccount']),
    rowData: {
      get () {
        return JSON.parse(JSON.stringify(this.audiences))
      }
    },
    isEdit() {
      return this.editId !== -1
    }
  },
  beforeMount () {
    this.gridOptions = {
      components: {
        dataTableCellAudience: DataTableCellAudience
      }
    }
  },
  async mounted () {
    await Promise.all([
      this.listAdvertisers(),
      this.listCategories(),
      this.listCampaign(),
      this.listAdCampaign(),
      this.listAdCampaignGroup(),
      this.listLineItem(),
      this.listSearchKeyword(),
      this.listSegment(),
      this.listEcUserCategories()
    ])
  },
  methods: {
    ...mapActions('amcAudience', [
      'listAdvertisers',
      'listCategories',
      'listCampaign',
      'listAdCampaign',
      'listAdCampaignGroup',
      'listLineItem',
      'listSearchKeyword',
      'listSegment',
      'listEcUserCategories',
      'listAudiences',
      'listDeliveries',
      'addAudience',
      'addDelivery'
    ]),
    fetchData: debounce(async (self) => {
      try {
        const payload = {
          page: self.currentPage,
          per_page: self.pageSize
        }
        const res = await self.listAudiences(payload)
        self.total = res.data.total
      } catch (e) {
        console.log(e)
      }
    }, 500),
    onUpdateCurrentPage (val) {
      this.currentPage = val
      this.fetchData(this)
    },
    onUpdatePaginationPageSize (val) {
      this.currentPage = 1
      this.pageSize = val
      this.fetchData(this)
    },
    async onClickAudience ({ index }) {
      await this.initialize()
      const target = structuredClone(this.rowData[index]);
      this.editId = target['id'];
      this.audience.audienceCategory = {text: audienceCategory[target.audienceCategory] , value: target.audienceCategory}
      this.audience.advertiserId = target.advertiserId
      this.audience.audienceName = target.audienceName
      this.audience.audienceDescription = target.audienceDescription
      this.audience.params = target.params
      this.audience.audience1 = target.audience1
      this.audience.audience2 = target.audience2
      this.audience.audience3 = target.audience3
      this.audience.audience4 = target.audience4
      this.audience.audience5 = target.audience5
      this.audience.audience6 = target.audience6
      this.audience.audience7 = target.audience7
      this.showAudienceForm = true
    },
    async onClickRegister ({ index }) {
      await this.initialize()
      const target = structuredClone(this.rowData[index]);
      this.editId = target['id'];
      this.audience.advertiserId = target.advertiserId
      this.audience.audienceName = target.audienceName
      this.showDeliveryRegisterForm = true
    },
    async onClickDelivery ({ index }) {
      await this.initialize()
      const target = structuredClone(this.rowData[index]);
      this.editId = target['id'];
      this.audience.advertiserId = target.advertiserId
      this.audience.audienceName = target.audienceName
      await this.listDeliveries({ amcAudienceId: this.editId })
      this.showDeliveryListForm = true
    },
    async onClick () {
      await this.initialize()
      this.editId = -1
      this.showAudienceForm = true
    },
    async onClickSubmit () {
      try {
        const result = await this.$refs.amcAudienceFormObserver.validate()
        if (!result.valid) return
        const audienceCategory = this.audience.audienceCategory.value
        const data = {
          audienceCategory,
          advertiserId: this.audience.advertiserId,
          audienceName: this.audience.audienceName,
          audienceDescription: this.audience.audienceDescription,
        }
        if (audienceCategory === 1) {
          await this.addAudience({
            ...data,
            params: {
              audience_type: this.audience.params.audience_type,
              categories: this.audience.params.categories,
              user_rank: this.audience.params.user_rank,
            },
            audience1: this.audience.audience1.map(a => a.value),
            audience2: this.audience.audience2.map(a => a.value),
            audience3: this.audience.audience3.map(a => a.value),
            audience4: this.audience.audience4.map(a => a.value),
            audience5: this.audience.audience5.map(a => a.value),
            audience6: this.audience.audience6.map(a => a.value),
            audience7: this.audience.audience7.map(a => a.value)
          })
        } else if (audienceCategory === 2) {
          await this.addAudience({
            ...data,
            params: {
              audience_type: this.audience.params.audience_type,
              event: this.audience.params.event,
              frequency: this.audience.params.frequency,
              category: this.audience.params.category,
              categories: this.audience.params.categories,
              asin: this.audience.params.asin,
              new_user: this.audience.params.new_user,
              period: this.audience.params.period,
              except_event: this.audience.params.except_event,
              except_category: this.audience.params.except_category,
              except_categories: this.audience.params.except_categories,
              except_period: this.audience.params.except_period,
            }
          })
        } else if (audienceCategory === 3) {
          await this.addAudience({
            ...data,
            params: {
              order: this.audience.params.order,
              line_item: this.audience.params.line_item,
              reach_type: this.audience.params.reach_type,
              frequency: this.audience.params.frequency,
              frequency_type: this.audience.params.frequency_type,
              period: this.audience.params.period,
              except_event: this.audience.params.except_event,
              except_category: this.audience.params.except_category,
              except_categories: this.audience.params.except_categories,
              except_period: this.audience.params.except_period,
            }
          })
        } else if (audienceCategory === 4) {
          await this.addAudience({
            ...data,
            params: {
              audience_type: this.audience.params.audience_type,
              category1: this.audience.params.category1,
              category2: this.audience.params.category2,
              category3: this.audience.params.category3,
              category4: this.audience.params.category4,
              category5: this.audience.params.category5,
              except_event: this.audience.params.except_event,
              except_category: this.audience.params.except_category,
              except_categories: this.audience.params.except_categories,
              except_period: this.audience.params.except_period,
            }
          })
        } else if (audienceCategory === 5) {
          await this.addAudience({
            ...data,
            params: {
              search_keyword: this.audience.params.search_keyword,
              except_event: this.audience.params.except_event,
              except_category: this.audience.params.except_category,
              except_categories: this.audience.params.except_categories,
              period: this.audience.params.period,
              except_event: this.audience.params.except_event,
              except_category: this.audience.params.except_category,
              except_categories: this.audience.params.except_categories,
              except_period: this.audience.params.except_period,
            }
          })
        } else if (audienceCategory === 6) {
          await this.addAudience({
            ...data,
            params: {
              segment: this.audience.params?.segment,
              except_event: this.audience.params?.except_event,
              except_category: this.audience.params?.except_category,
              except_categories: this.audience.params?.except_categories,
              except_period: this.audience.params?.except_period,
            }
          })
        }
        this.showAudienceForm = false
        window.setTimeout(async () => {
          await this.initialize()
        }, 1000)
        this.fetchData(this)
      } catch (e) {
        console.log(e)
      }
    },
    async onClickDeliverySubmit () {
      try {
        const result = await this.$refs.amcAudienceDeliveryRegisterFormObserver.validate()
        if (!result.valid) return
        await this.addDelivery({
          amcAudienceId: this.editId,
          adType: this.audience.adType,
          campaignId: this.audience.campaignId,
          campaignName: this.audience.campaignName,
          bidAjustment: this.audience.bidAjustment,
          adGroupId: this.audience.adGroupId,
          adGroupName: this.audience.adGroupName,
          bid: this.audience.bid,
        })
        this.showDeliveryRegisterForm = false
        window.setTimeout(async () => {
          await this.initialize()
        }, 1000)
        this.fetchData(this)
      } catch (e) {
        console.log(e)
      }
    },
    async onChangeAudienceCategory () {
      await this.initialize(false)
    },
    async initialize (isInitAudienceCategory = true) {
      if (isInitAudienceCategory === true) {
        this.audience.audienceCategory = null
      }
      this.audience.advertiserId = null
      this.audience.audienceName = null
      this.audience.audienceDescription = null
      this.audience.params = null
      this.audience.audience1 = []
      this.audience.audience2 = []
      this.audience.audience3 = []
      this.audience.audience4 = []
      this.audience.audience5 = []
      this.audience.audience6 = []
      this.audience.audience7 = []
      this.audience.adType = null
      this.audience.campaignId = null
      this.audience.campaignName = null
      this.audience.bidAjustment = null
      this.audience.campaignAndAdGroup = null
      this.audience.adGroupId = null
      this.audience.adGroupName = null
      this.audience.bid = null
      await this.$refs.amcAudienceFormObserver.resetForm()
      await this.$refs.amcAudienceDeliveryRegisterFormObserver.resetForm()
      await this.$refs.amcAudienceForm.resetOption()
    }
  }
}
</script>

<style scoped>
.ad-audience-modal :deep(.vs-popup),
.ad-audience-delivery-register-modal :deep(.vs-popup) {
  width: 650px;
}
.ad-audience-modal :deep(.vs-popup--content):has(.no-category-selected),
.ad-audience-delivery-register-modal :deep(.vs-popup--content):has(.no-category-selected) {
  overflow: visible !important;
}
.ad-audience-delivery-list-modal :deep(.vs-popup) {
  width: 1100px;
}
.ad-audience-delivery-list-modal :deep(.vs-popup--content):has(.no-category-selected) {
  overflow: visible !important;
}
</style>
